import getProductAbbreviationByPath from '@/creditflowresearch/infrastructure/productRouting';
import { validateUrlFilter } from '@/creditflowresearch/application/PageFiltersState/productRegionFilters/validateUrlFilter';
import { IgetValidChangeProductsRes } from './types';
import { IProduct } from '@/creditflowresearch/domain/vo/Product';
import { IRegion } from '@/creditflowresearch/domain/vo/Region';
import Region from '@/creditflowresearch/domain/Region';

interface IHeaderData {
  productsCollection: IProduct[],
  regionsCollection: IRegion[],
  pathname: string,
  query: Record<string, string | string[] | undefined>,
}
// TODO refactror after redux state ts coverage
export const getValidChangedProducts = (headerData: IHeaderData): IgetValidChangeProductsRes => {
  const { pathname, query } = headerData;

  const {
    updatedQuery: validProducts,
    hasChanged: productsChanged,
  } = validateUrlFilter(
    query.products as string,
    headerData.productsCollection,
    getProductAbbreviationByPath(pathname),
  );

  const {
    updatedQuery: validRegions,
    hasChanged: regionsChanged,
  } = validateUrlFilter(query.regions as string, headerData.regionsCollection, Region.getDefaultAbbreviation());

  return {
    pathname,
    validProducts,
    validRegions,
    productsChanged,
    regionsChanged,
  };
};
